/**
 * Cookie read by the splash templates at HTML parse time, before any JS
 * bundle runs, so the loading screen renders in the resolved language ahead
 * of bootstrap. Both templates inline a reader for this cookie:
 * `apps/ardoq-front/vite-entry/template.html` and
 * `apps/ardoq-front/src/js/entry/template.html`. Keep this constant in sync
 * with the inline readers in both templates.
 */
export const PRE_APP_LANGUAGE_COOKIE = 'ardoq_pre_app_lang';

const PRE_APP_LANGUAGE_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

/**
 * Persists the resolved BCP-47 language tag so the next full page load can
 * render the splash in the correct language before the JS bundle resolves it
 * again. Invoked from both the pre-app bootstrap (unauthenticated entry
 * points) and the authenticated `translationSyncRoutine` so the cookie stays
 * current whenever the resolved language changes.
 */
export const writePreAppLanguageCookie = (language: string): void => {
  document.cookie = `${PRE_APP_LANGUAGE_COOKIE}=${language};path=/;max-age=${PRE_APP_LANGUAGE_COOKIE_MAX_AGE_SECONDS};SameSite=Lax`;
};
